<template>
  <client-only>
    <div
      v-if="theme === 'dropdown'"
      class="molecules-share-buttons"
    >
      <atoms-popover-v2
        :has-shadow="true"
        :position="devices.isDesktop.value ? 'right' : 'left'"
        action-type="click"
        inner-class="!z-[1]"
        :position-left-adjustment="15"
      >
        <span class="underline inline-flex items-cente cursor-pointer text-sm gap-2">
          <AtomsImage
            src="/icons/share.svg"
            alt="share"
            width="18"
            height="18"
            class="w-[18px]"
            :image-lazy-load="imageLazyLoad"
          />

          <strong class="hidden md:inline-block">
            {{ props.title }}
          </strong>
        </span>

        <template #content>
          <ul class="flex items-center flex-wrap gap-2 md:gap-5">
            <li
              v-for="(button, index) in buttons"
              :key="index"
              class="inline-flex items-center"
            >
              <AtomsLinkSocialMedia
                v-if="button.name !== 'Copy'"
                :social="button.name"
                :class="[
                  devices.isDesktop.value ? sizes[size] : sizes.small
                ]"
                :to="generateShareUrl(button.url, button.name)"
                :image-lazy-load="imageLazyLoad"
                class="!mr-0"
              />

              <AtomsButtonCopy
                v-else
                :text="button.url"
              >
                {{ button.text ? button.text : 'Link' }}
              </AtomsButtonCopy>
            </li>
          </ul>
        </template>
      </atoms-popover-v2>
    </div>

    <ul
      v-else
      class="molecules-share-buttons flex items-center flex-wrap"
    >
      <li
        v-if="props.title"
        class="mr-5 w-full lg:w-auto mb-2.5 lg:mb-0"
      >
        <p class="text-lg font-bold">
          {{ props.title }}
        </p>
      </li>

      <li
        v-for="(button, index) in buttons"
        :key="index"
        class="inline-flex items-center"
      >
        <AtomsLinkSocialMedia
          v-if="button.name !== 'Copy'"
          :social="button.name"
          :class="sizes[size]"
          :to="generateShareUrl(button.url, button.name)"
          :image-lazy-load="imageLazyLoad"
        />

        <AtomsButtonCopy
          v-else
          :size="size"
          :text="button.url"
          :class="
            button.hideTextOnMobile
              ? 'text-[0px] md:text-sm leading-none md:leading-tight !pr-3 md:pr-4'
              : ''
          "
          :image-lazy-load="imageLazyLoad"
        >
          {{ button.text ? button.text : 'Link' }}
        </AtomsButtonCopy>
      </li>
    </ul>
  </client-only>
</template>

<script setup>
import { arrayObjectPropValidator } from '~/helpers/validator'

defineOptions({
  name: 'MoleculesShareButtons'
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },

  size: {
    type: String,
    default: 'default',
    validator: value => ['xxsmall', 'small', 'default', 'medium'].includes(value)
  },

  buttons: {
    type: Array,
    default: () => [
      {
        name: 'Email',
        url: 'mailto:someone@example.com'
      },
      {
        name: 'Copy',
        url: 'someone@example.com'
      }
    ],
    validator: arr => {
      return arrayObjectPropValidator(arr, ['name', 'url'])
    }
  },

  theme: {
    type: String,
    default: 'default',
    validator: value => {
      return ['default', 'dropdown'].includes(value)
    }
  },

  imageLazyLoad: {
    type: Boolean,
    default: false
  }
})

const { devices } = deviceChecker()
const sizes = {
  xxsmall: 'w-[13px] h-[13px] mr-1.5',
  xsmall: 'w-[20px] h-[20px] mr-2',
  small: 'w-[24px] h-[24px] mr-2',
  medium: 'w-[26px] h-[26px] mr-3',
  default: 'w-[26px] h-[26px] md:w-[33px] md:h-[33px] mr-5'
}

const generateShareUrl = (url, socialMedia) => {
  const utms = '?' + transformObjectToQueryUrl({
    campaign_medium: 'organic',
    campaign_source: socialMedia?.toLowerCase(),
    campaign_name: 'share',
    campaign_term: 'social_media'
  })

  return `${url}${encodeURIComponent(utms)}`
}

</script>
